import { render, staticRenderFns } from "./TrainingCoursesCrudDocuments.vue?vue&type=template&id=1da517d5&"
import script from "./TrainingCoursesCrudDocuments.vue?vue&type=script&lang=js&"
export * from "./TrainingCoursesCrudDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports